import { workorderChecklistQuickListOptions } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.QuickConstant';
import { ReportChecklistData } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

interface Props {
  checklist: ReportChecklistData;
}

const ReportChecklistQuickChecklist: React.FC<Props> = ({ checklist }) => {
  const listSize = workorderChecklistQuickListOptions.length;
  const firstList = workorderChecklistQuickListOptions.slice(
    0,
    Math.round(listSize / 2),
  );
  const secondList = workorderChecklistQuickListOptions.slice(
    Math.round(listSize / 2),
    listSize,
  );

  return (
    <div className="reportChecklist-quickChecklist">
      <div
        className={`reportChecklist-quickChecklist-header  ${
          checklist.company?.bosch ? '-bosch' : ''
        }`}
      >
        <span>Checklist rápido</span>
      </div>
      <div className="row">
        <ul className="w-50 quick-col">
          {firstList.map((item) => {
            const a = checklist.checklistQuicks?.find(
              (quick) => quick.description === item.value,
            );
            const className =
              typeof a?.response === 'boolean'
                ? a.response
                  ? 'check'
                  : 'uncheck'
                : '';

            return (
              <li key={item.value} className={className}>
                {item.label}
              </li>
            );
          })}
        </ul>

        <ul className="w-50 quick-col">
          {secondList.map((item) => {
            const a = checklist.checklistQuicks?.find(
              (quick) => quick.description === item.value,
            );
            const className =
              typeof a?.response === 'boolean'
                ? a.response
                  ? 'check'
                  : 'uncheck'
                : '';

            return (
              <li key={item.value} className={className}>
                {item.label}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="reportChecklist-quickChecklist-legends">
        <div>
          <span className="icon-ok">&#9745;</span>
          <span>Ok</span>
        </div>
        <div>
          <span className="icon-notOk">&#9746;</span>
          <span>Não Ok</span>
        </div>
        <div>
          <span className="icon-uncheck">&#9744;</span>
          <span>Não checado</span>
        </div>
      </div>
    </div>
  );
};

export default ReportChecklistQuickChecklist;
